module.exports = __webpack_public_path__ + "img/logo.e1644e67.png";